import React, {useContext} from "react"
import {injectIntl} from "react-intl";
import Column from "@amzn/meridian/column";
import {PROTOCOLS} from "../../util/Validations";
import {AUTO_RETRIEVER_ASSET_TYPE} from "../../util/Constants";
import CommonDeviceLogstream from "../../commonui/CommonDeviceLogstream";
import {AutoRetrieverDeviceOverviewContext} from "./context/AutoRetrieverDeviceOverviewContext";

const AutoRetrieverDeviceLogstream = ({intl}) => {

    const {viewModel, dispatch} = useContext(AutoRetrieverDeviceOverviewContext);
    const deviceList = Object.values(viewModel.autoRetrieverDeviceInformation);

    const props = {
        protocols: PROTOCOLS.AUTO_RETRIEVER,
        dispatch,
        deviceList,
        deviceType: AUTO_RETRIEVER_ASSET_TYPE,
        intl
    }
    return (
        <Column>
            <CommonDeviceLogstream {...props}/>
        </Column>
    );
}

export default injectIntl(AutoRetrieverDeviceLogstream)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoretriever/AutoRetrieverDeviceLogstream.js